module.exports = __webpack_public_path__ + "img/logo.6288342e.png";